import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CharterAgreementSigningRoutingModule } from './charter-agreement-signing-routing.module';
import { CharterAgreementSigningComponent } from './charter-agreement-signing.component';
import { LoadingModule } from '../../../shared/loading/loading.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CustomerSignAgreementDialogModule } from '../../../shared/dialogs/customer-sign-agreement-dialog/customer-sign-agreement-dialog.module';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [CharterAgreementSigningComponent],
  imports: [
    CommonModule,
    CharterAgreementSigningRoutingModule,
    LoadingModule,
    MatCheckboxModule,
    MatButtonModule,
    CustomerSignAgreementDialogModule,
    PdfJsViewerModule,
    MatProgressBarModule,
  ],
})
export class CharterAgreementSigningModule {}
